<template>
  <div
    ref="inviewRef"
    :class="[
      'bg-surface-light border border-surface-grey rounded-md transition duration-500 delay-400',
      inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4',
    ]"
  >
    <div class="p-4 md:p-6 space-y-4">
      <div class="flex flex-col md:flex-row justify-between items-start">
        <div class="mb-4">
          <div
            v-if="ticket.section_name"
            class="text-primary text-sm mb-1 font-semibold"
          >
            {{ ticket.section_name }}
          </div>

          <div class="h4 mb-1">
            {{ getLocalizedTicketValue(ticket, $i18n.locale, 'name1') }}
          </div>
          <div v-if="ticket.name2" class="text-text text-sm">
            {{ getLocalizedTicketValue(ticket, $i18n.locale, 'name2') }}
          </div>
        </div>

        <div v-if="ticket.type" class="flex flex-wrap gap-2">
          <span class="inline-block text-xs px-2 py-1 font-semibold rounded-sm border-1 border-surface-grey bg-surface-light text-text" >
            {{ ticket.type }}
          </span>
        </div>
      </div>

      <div class="flex justify-between items-center">
        <div>
          <div class="flex items-baseline space-x-2">
            <div class="heavy">
              {{ formatPrice(ticket.price, event.currency, $i18n.locale) }}
            </div>

            <!--div
              v-if="ticket.beforePrice"
              class="text-text line-through text-sm"
            >
              {{ $t('common.before') }}
              {{
                formatPrice(ticket.beforePrice, event.currency, $i18n.locale)
              }}
            </div -->
          </div>
          <div class="text-text text-sm" v-if="actualTicketFee && actualTicketFee > 0">
            + {{ formatPrice(actualTicketFee, event.currency, $i18n.locale) }}
            {{ $t('common.fee') }}
          </div>
        </div>

        <InputCount
            class="w-34"
            v-model="cart.currentCount[ticket.id]"
            :step="ticket.buy_amount_increment"
            :max="ticket.maxtickets"
            :first-step="ticket.mintickets"
            required
          />
      </div>
    </div>

    <BaseSlideTransition>
      <div v-if="cart.currentOrderData.customfields_data && eventID && cart.currentOrderData.customfields_data[eventID] && cart.currentCount[ticket.id] > 0">
        <div
          class="py-4 px-6 border-t border-surface-grey bg-surface-grey-light font-semibold"
        >
          {{ $t('checkout.add_info_to', { name: getLocalizedTicketValue(ticket, $i18n.locale, 'name1') }) }}
        </div>

        <CheckoutCustomFields
          type="ticket"
          :ticket-id="ticket.id"
          :event-id="eventID"
          :filters="['per_ticket','per_tickettype']"
          :errors="undefined"
        />
      </div>
    </BaseSlideTransition>
  </div>
</template>

<script setup lang="ts">
  import { ref, watch, computed } from 'vue';

  import { useCartStore } from '@/stores/cart';
  import type { EventCheckoutData, TicketCheckoutData } from '@/types';
  import { formatPrice } from '@/utils/formatPrice';
  import { useInView } from '@/utils/useInView';

  import BaseSlideTransition from '../ui/BaseSlideTransition.vue';
  import InputCount from '../ui/inputs/InputCount.vue';
  import CheckoutCustomFields from './CheckoutCustomFields.vue';
  import { getLocalizedTicketValue } from '@/utils/ticketItemUtil';

  const props = defineProps<{
    ticket: TicketCheckoutData;
    event: EventCheckoutData;
    eventID: number | undefined;
  }>();

  //const customField = ref<CustomField[]>([]); // temp value, was ticket.customFields above!
  //const tags = ref(['VIP', 'Backstage']); // temp value, was ticket.tags above!

  const cart = useCartStore();

  const cartEvent = cart.items.find(
    item => item.id === props.eventID,
  );

  console.log('CheckoutTicket - cart items:', cart.items);
  console.log('CheckoutTicket - looking for event ID', props.eventID, 'found:', cartEvent);
  console.log('Event data for event ID', props.eventID, ':', props.event);
  // console.log('CheckoutTicket - cartEvent for event ID', props.eventID, ':', cartEvent);
  const ticketCount = cartEvent?.tickets.find(t => t.id == props.ticket.id)?.count || 0;

  cart.currentCount[props.ticket.id] = ticketCount;


  const timeoutId = ref<number | undefined>();
  // console.log('CheckoutTicket - ticket count for ticket ID', props.ticket.id, 'is', cart.currentCount[props.ticket.id]);

  const actualTicketFee = computed(() => {
    const ticketfee_extra =  props.ticket.price * props.ticket.ticketfee_extra;
    const ticketfee = props.ticket.ticketfee;
    return ticketfee + ticketfee_extra;
  });

  // Debounce the ticket selection to avoid rapid calls
  watch(() => cart.currentCount[props.ticket.id], newCount => {
    clearTimeout(timeoutId.value);
    if(cart.differentCountCalculating){
      return; // if we're currently calculating differentCount, we don't want to trigger another selectTickets until it's done
    }
    console.log('Ticket count changed for ticket ID', props.ticket.id, 'new count:', newCount);
    timeoutId.value = window.setTimeout(() => {
      cart.selectTickets(props.eventID, props.ticket.id, newCount);
    }, 500);
  });

  const { inviewRef, inView } = useInView();
</script>
